import { PlatformChartComingSoonCard } from './PlatformChartComingSoonCard'

export function EkycStatusPlaceholder() {
  return (
    <PlatformChartComingSoonCard
      title="eKYC Status Breakdown"
      testId="platform-ekyc-placeholder"
    />
  )
}
